import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { CLOVER_PRIVACY_POLICY_URL } from 'reservations/base/constants/bentobox';

export const marketingOptInMessageDisplayHelper = (
  isEmailOptIn: boolean,
  isSmsOptIn: boolean,
  restaurantName: string
) => {
  if (isEmailOptIn && isSmsOptIn) {
    return (
      <Typography variant="caption">
        Clover/BentoBox will send you reservation updates by email and to your
        mobile phone. By checking the boxes above, you also consent to receiving
        marketing and rewards messages from {restaurantName} via SMS and email.
        Consent is not a condition of purchase. Msg & data rates may apply.
        Message frequency varies. For SMS, reply STOP to unsubscribe or HELP for
        help. See{' '}
        <Link href={CLOVER_PRIVACY_POLICY_URL} target="_blank" rel="noopener">
          Clover.com/privacy-policy
        </Link>{' '}
        for more info.
      </Typography>
    );
  }
  if (isEmailOptIn) {
    return (
      <Typography variant="caption">
        Clover/BentoBox will send you reservation updates by email. By checking
        the box above, you also consent to receiving marketing and rewards
        messages from {restaurantName}. See{' '}
        <Link href={CLOVER_PRIVACY_POLICY_URL} target="_blank" rel="noopener">
          Clover.com/privacy-policy
        </Link>{' '}
        for more info.
      </Typography>
    );
  }
  if (isSmsOptIn) {
    return (
      <Typography variant="caption">
        Clover/BentoBox will send you reservation updates to your mobile phone.
        By checking the box above, you also consent to receiving recurring
        automated marketing and rewards messages from {restaurantName} via SMS.
        Consent is not a condition of purchase. Msg & data rates may apply.
        Message frequency varies. Reply STOP to unsubscribe or HELP for help.
        See{' '}
        <Link href={CLOVER_PRIVACY_POLICY_URL} target="_blank" rel="noopener">
          Clover.com/privacy-policy
        </Link>{' '}
        for more info.
      </Typography>
    );
  }
  return;
};
